export default __webpack_public_path__ + "static/media/hero_section_mobile.67b5fd46.gif";